import { useStore } from '@/store';
import type { UserWorkspace } from '@/services/models';
import { getUserWorkspacesApiRequest } from '@/services/api/workspaces-api';

export const refreshUserWorkspaces = async (): Promise<UserWorkspace[]> => {
  const workspaces = await getUserWorkspacesApiRequest();
  const store = useStore();
  store.mergeUser({ workspaces });
  return workspaces;
};
